/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextAlignLeftJustifyIcon16Solid = forwardRef('TextAlignLeftJustifyIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3 2a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H3Z" }),
        React.createElement("path", { d: "M2 6a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M3 8a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H3Z" }),
        React.createElement("path", { d: "M3 11a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H3Z" })));
});
